import React from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import cx from 'classnames';
import { Navbar, NavbarBrand, NavbarContainer, NavbarItem, NavbarMenu } from 'components/Navbar';
import { Box } from 'components/Wrapped';
import { AuthenticatedNav, PublicNav } from 'containers/TopBar';
import { Button, Modal } from 'components/Wrapped';
import { Tooltip } from 'components/Tooltip';
import { Services } from 'grommet-icons';
import { Settings } from 'containers/Settings';
import { TradingRequirements } from 'containers/TradingRequirements';
import styles from './TopBar.module.scss';

export const SettingsModal = () => {
  return (
    <Modal
      position="center"
      trigger={
        <Button
          icon={
            <Tooltip position="bottom" translation="settings">
              <Services size="medium" />
            </Tooltip>
          }
          plain
        ></Button>
      }
    >
      <Settings />
    </Modal>
  );
};

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      p2pEligible: true,
      isOpen: false,
      isScrolled: false,
    };
  }

  toggleModal = () => this.setState({ isOpen: !this.state.isOpen });

  tradingRequirements = () => {
    const {
      profile: { kycStatus, isMobileVerified, loginName },
    } = this.props;
    if (!_.isEqual(kycStatus.toLowerCase(), 'approved') || !isMobileVerified || _.isEqual(loginName, '')) {
      this.setState({ p2pEligible: false, isOpen: true });
    }
  };

  handleScroll = () => {
    if (window.scrollY > 0) {
      this.setState({ isScrolled: true });
    } else {
      this.setState({ isScrolled: false });
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { isAuthenticated, enableDSSO, mgokx, scrollable = true } = this.props;
    // const t = nestedTranslate(translate, 'navbar.links');
    // const ts = nestedTranslate(translate, 'tables.offers');

    return (
      <Navbar
        backgroundColor={this.state.isScrolled ? '#0A171E' : 'transparent'}
        className={cx(styles.navbar, {
          [styles.navbar_fixed]: scrollable,
        })}
      >
        <Box pad="none" round={false} direction="row" fill={true} background="navbarBackground">
          <NavbarBrand logo="/assets/img/logo.png" isAuthenticated={isAuthenticated} />
          <NavbarMenu>
            <NavbarContainer>
              {/* {!isAuthenticated ? (
                <NavbarItem
                  to="/"
                  exact
                  // navIcon={require('assets/icons/market.svg')}
                >
                  Купить криптовалюту
                </NavbarItem>
              ) : (
                <NavbarItem
                  to="/"
                  exact
                  // navIcon={require('assets/icons/market.svg')}
                >
                  В 1 клик
                </NavbarItem>
              )}
              <NavbarItem
                to="/"
                exact
                // navIcon={require('assets/icons/market.svg')}
              >
                Рынки
              </NavbarItem> */}
              <NavbarItem
                to="/trade"
                // navIcon={require('assets/icons/bar-chart.svg')}
              >
                Спот
              </NavbarItem>
              {/* <NavbarItem
                to="/trade"
                // navIcon={require('assets/icons/bar-chart.svg')}
              >
                P2P
              </NavbarItem>
              <NavbarItem
                to="/trade"
                // navIcon={require('assets/icons/bar-chart.svg')}
              >
                Новости
              </NavbarItem>
              {enableInstaTrade && (
                <NavbarItem
                  to="/insta-trade"
                  // navIcon={require('assets/icons/bar-chart.svg')}
                >
                  {t('instaTrade')}
                </NavbarItem>
              )}
              {enableSocialTrade && (
                <NavbarItem to="/social-trade">{t('socialTrade')}</NavbarItem>
              )}
              {enableP2PTrading && (
                <React.Fragment>
                  {!isAuthenticated && (
                    <NavbarItem to="/p2p">{t('p2pMenu.p2p')}</NavbarItem>
                  )}
                  {isAuthenticated && (
                    <Menu
                      label={<Text size="medium">{t('p2pMenu.p2p')}</Text>}
                      items={[
                        {
                          label: t('p2pMenu.offers'),
                          onClick: () => {
                            history.push(`/p2p/`);
                          },
                        },
                        {
                          label: t('p2pMenu.paymentSettings'),
                          onClick: () => {
                            this.tradingRequirements();
                            history.push(`/p2p/payment-settings`);
                          },
                        },
                        {
                          label: t('p2pMenu.postNewOffer'),
                          onClick: () => {
                            this.tradingRequirements();
                            history.push(`/p2p/post-offer`);
                          },
                        },
                        {
                          label: t('p2pMenu.MyOffers'),
                          onClick: () => {
                            this.tradingRequirements();
                            history.push(`/p2p/my-offers`);
                          },
                        },
                        {
                          label: t('p2pMenu.MyOrders'),
                          onClick: () => {
                            this.tradingRequirements();
                            history.push(`/p2p/my-orders`);
                          },
                        },
                        {
                          label: t('p2pMenu.p2pWallet'),
                          onClick: () => {
                            this.tradingRequirements();
                            history.push(`/p2p/p2p-wallet`);
                          },
                        },
                      ]}
                      size="small"
                    />
                  )}
                </React.Fragment>
              )} */}
            </NavbarContainer>
            <NavbarContainer position="end">
              {/* <Mobile>
                <Route
                  path="/"
                  render={({ location }) =>
                    location.pathname.includes('/trade') && <NavCoinPicker />
                  }
                />
              </Mobile> */}

              {isAuthenticated ? (
                <AuthenticatedNav topNav={true} enableDSSO={enableDSSO} mgokx={mgokx} />
              ) : (
                <PublicNav loginButtonTheme={this.state.isScrolled ? 'gray' : 'black'} />
              )}

              {/* <Box pad="none" direction="row" gap="8px">
                <LanguageToggler
                  buttonTheme={this.state.isScrolled ? 'transparent' : 'black'}
                />
                <ThemeToggler
                  buttonTheme={this.state.isScrolled ? 'transparent' : 'black'}
                />
              </Box> */}

              <TradingRequirements show={this.state.isOpen} p2pEligible={this.state.p2pEligible} handleSuccess={this.toggleModal} />
            </NavbarContainer>
          </NavbarMenu>
        </Box>
      </Navbar>
    );
  }
}

const mapStateToProps = ({ auth, exchangeSettings: { settings }, user }) => ({
  isAuthenticated: auth.isAuthenticated,
  logoUrl: settings.logoUrl,
  enableInstaTrade: settings.enableInstaTrade,
  enableP2PTrading: settings.enableP2PTrading,
  enableSocialTrade: settings.enableSocialTrade,
  enableDSSO: settings.enableDSSO,
  mgokx: settings.mgokx,
  profile: user.profile,
});

export default withRouter(withNamespaces()(connect(mapStateToProps)(TopBar)));
